import { Text, types, useAdminContext } from "react-bricks/frontend"

import React from "react"
import { svgOptions, Svgs } from "../../../types"
import SvgIcons from "../../components/icon/svgIcons"
import classNames from "classnames"

export interface MatrixRedesignUspProps {
    index?: number
    icon: Svgs
}

const MatrixRedesignUsp: types.Brick<MatrixRedesignUspProps> = ({ index, icon }) => {
    const { isAdmin } = useAdminContext()

    return (
        <li
            key={index}
            className="grid grid-cols-[40px_1fr] gap-4.5 sm:grid-cols-[auto_1fr] sm:gap-3 md:gap-3.5 lg:max-w-[320px] lg:gap-4.5"
        >
            <SvgIcons
                icon={icon}
                className={classNames("self-start justify-self-end fill-orange", {
                    "w-10 sm:w-[51px] lg:w-[45px]": icon === Svgs.shipping,
                    "w-9 lg:w-10": icon === Svgs.bill,
                    "w-7 sm:w-7.5 lg:w-8": icon === Svgs.glass,
                })}
            />
            <div className={classNames("w-full", { "lg:w-fit": !isAdmin })}>
                <Text
                    propName="headline"
                    renderBlock={({ children }) => (
                        <p className="mb-0.5 font-gibson text-md sm:mb-1 lg:text-lg">{children}</p>
                    )}
                    placeholder="Lorem ipsum"
                />
                <Text
                    propName="text"
                    renderBlock={({ children }) => <p className="text-base lg:text-md">{children}</p>}
                    placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr"
                />
            </div>
        </li>
    )
}

MatrixRedesignUsp.schema = {
    name: "MatrixRedesignUsp",
    label: "Matrix Redesign Usp",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "icon",
            label: "Icon",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: svgOptions,
                display: types.OptionsDisplay.Select,
            },
        },
    ],
    getDefaultProps: (): MatrixRedesignUspProps => ({
        icon: Svgs.shipping,
    }),
}

export default MatrixRedesignUsp
